export const CONTENT_TYPE_HEADER = 'Content-Type'
export const AUTHORIZATION_HEADER = 'Authorization'
export const JSON = 'application/json'
